import {Component, Input, OnInit} from '@angular/core';
import {ModalService} from "../../services/modalService";
import {BookingService} from "../../services/booking.service";
import {AppUtilityService} from "../../services/AppUtilityService";

@Component({
  selector: 'app-track-booking',
  templateUrl: './track-booking.component.html',
  styleUrls: ['./track-booking.component.css']
})
export class TrackBookingComponent implements OnInit {

  @Input() trackNo: any;
  trackingEvents: any = [];
  booking: any;

  constructor(public modalService: ModalService, private appUtil: AppUtilityService) {}

  ngOnInit(): void {
   
    this.trackingEvents = this.appUtil.persistenceService().get('trackingData').trackingInfo;
    console.log(this.trackingEvents.length)
    // console.log(this.booking);
    if(this.trackingEvents.length == 0 ){
      this.modalService.closeModal()
      this.modalService.openTrackErrorModal();
    }
  }

  /*getTrackingEvents(){
    this.bookingService.trackbooking(this.trackNo.trackNo).subscribe(
      (response)=> {
        console.log(response)
        this.appUtil.loaderService().removeLoader();
        if (response.error) {
          this.appUtil.errorService().showErrorToast(response.error.message);
        } else {
          this.booking = response.booking;
          this.trackingEvents = response.trackingInfo;
        }
      }
    );
  }*/

  closeModal(): void {
    this.modalService.closeModal();
  }

}
